module.exports = __webpack_public_path__ + "static/media/objectives-bg.9f398538.svg";